import { CategoryType } from "../../types/Library";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get, post, put } from "../../utils/axios-config";
import { CATEGORY } from "../../utils/constants";

export const createCategory = async (data:CategoryType) => {
    return await post(CATEGORY, data);
  };
  export const updateCategory = async (data: CategoryType) => {
    return await put(CATEGORY, data);
  };
  export const getCategories = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${CATEGORY}?${queryParams.toString()}`;
    return await get<PagedResultsType<CategoryType>>(url)
};